export default __webpack_public_path__ + "static/media/beep-6-96243.2e4f9ee5.mp3";